import { GenericAbortSignal } from 'axios';
import { decamelizeKeys } from 'humps';

import { PAGE_STATUS_APPROVED } from 'constants/index';
import axiosApi from 'utils/axios';

import { getAccountId } from './auth';

export type IMasterProperty = {
  handle: string;
  id: number;
  name?: string;
  currentStep: string;
  systemWide: boolean;
  tags?: string[];
  shared?: boolean;
};

export type TParams = {
  types: string[];
  limit: number;
  statuses: string[];
  orderBy: string;
  countless: string;
};

export const fetchPages = async (
  req: string,
  params: Partial<TParams> = {},
  { signal }: { signal?: GenericAbortSignal } = {},
): Promise<IMasterProperty[]> => {
  const res = await axiosApi.get(`/acc/${getAccountId()}/pages/dropdown`, {
    signal,
    params: decamelizeKeys({
      types: [],
      limit: 100,
      statuses: [PAGE_STATUS_APPROVED],
      orderBy: 'handle',
      countless: '1',
      accountId: getAccountId(),
      q: req,
      ...params,
    }),
  });

  return res?.data?.data ?? [];
};
